import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInfoBadges extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * Updates delivery and stock badges when the variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector('product-info-badges');

    if (!newBadges) return;

    morph(this, newBadges, { childrenOnly: true });
  };
}

if (!customElements.get('product-info-badges')) {
  customElements.define('product-info-badges', ProductInfoBadges);
}
